module.exports = __webpack_public_path__ + "static/media/discountCodes.a91be786.svg";